export default __webpack_public_path__ + "static/Messaging Platform Header – HT – 1920x1200-6bd57319750cf6abc73a9b201c52c01a.jpg";